import React from 'react';
import { InjectedRouter } from 'react-router';
import { Location } from 'history';
import { compact } from 'lodash';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';

import CoachingHomeTabView, { Tab } from 'coaching/components/CoachingHomeView/CoachingHomeTabView';

import GetCoachingHomeDashboard from 'coaching/containers/GetCoachingHomeDashboard';
import ErrorReporter from 'app/components/ErrorReporter';
import { withRouter } from 'app/context/Router';
import CoachingHomeView from 'coaching/components/CoachingHomeView/CoachingHomeView';
import CoachingBillingView from 'coaching/components/CoachingBillingView/CoachingBillingView';
import CoachingConstants from 'coaching/CoachingConstants';

export const coachingHomeEventPrefix = 'coaching.coaching_home_dashboard';

export function CoachingHomeContainer({
  router,
  location,
}: {
  router: InjectedRouter;
  location: Location;
}) {
  return (
    <GetCoachingHomeDashboard>
      {({ coachingHomeDashboard, shouldShowBillingTab, loading, error }) => {
        if (loading) {
          return <CenteredLoadingIndicator />;
        }
        if (!coachingHomeDashboard || error) {
          return <ErrorReporter error={`Could not load coaching home dashboard e=${error}`} />;
        }

        const tabs: Tab[] = compact([
          {
            title: 'Home',
            element: <CoachingHomeView {...{ coachingHomeDashboard, router }} headerType="none" />,
            route: CoachingConstants.COACHING_HOME_ROUTE,
          },
          shouldShowBillingTab && {
            title: 'Billing',
            element: <CoachingBillingView />,
            route: CoachingConstants.COACHING_BILLING_ROUTE,
          },
        ]);

        return (
          <CoachingHomeTabView
            title="Remind Tutoring"
            tabs={tabs}
            renderAllTabs={false}
            location={location}
            router={router}
          />
        );
      }}
    </GetCoachingHomeDashboard>
  );
}

export default withRouter(CoachingHomeContainer);
